import { render, staticRenderFns } from "./ValidateVideoTourModal.vue?vue&type=template&id=5d79b586&scoped=true"
import script from "./ValidateVideoTourModal.vue?vue&type=script&lang=js"
export * from "./ValidateVideoTourModal.vue?vue&type=script&lang=js"
import style0 from "./ValidateVideoTourModal.vue?vue&type=style&index=0&id=5d79b586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d79b586",
  null
  
)

export default component.exports